module.exports = "/_next/static/images/check-monotone-9f92295189f88a0269e9dfca63b5b80f.svg";